import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { DeliveryAward } from '../all-awards-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: DeliveryAreaService): GridSetup<DeliveryAward> {

	const staffPermissions = areaService.staffPermissions();

	return {
		rowName: { singular: 'Award', plural: 'Awards' },
		getRowKey: row => '' + row.awardId,
		stateKey: 'delivery-all-awards-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Awards`,
		}
	}
}
